import { protocols } from "../../../config/constants";

export const levelsByProtocol = 6;

export const isOnlyRGSICUVideoProtocol = (protocolId) => {
  const protocolIds = new Set([
    protocols.icu.WALK_AROUND_THE_ISLAND.id,
    protocols.icu.SUNSET_AMONG_POPPIES.id,
    protocols.icu.CALM_IN_THE_LAKE.id,
    protocols.icu.FLYING_OVER_THE_FIELDS.id,
    protocols.icu.RELAX_ON_THE_BEACH.id,
    protocols.icu.THE_SOUND_OF_WATER.id,
    protocols.icu.THE_SWAY_OF_THE_WAVES.id,
  ]);
  return protocolIds.has(Number(protocolId));
};

export const getSessionsWithSomeHitOrError = (sessions) => {
  return sessions.filter((session) => {
    return (
      (Object.keys(session).some((key) => key.startsWith("totalHits_level") || key.startsWith("totalErrors_level")) &&
        !isOnlyRGSICUVideoProtocol(session.PROTOCOL_ID)) ||
      isOnlyRGSICUVideoProtocol(session.PROTOCOL_ID)
    );
  });
};

export const localizationMapping = (key) => {
  const texts = {
    "-": "-",
    Encamado: "bedridden",
    Sentado: "seated",
    SÍ: "yes",
    NO: "no",
    "No invasiva": "Non-invasive",
    "Invasiva-intubación": "Invasive-intubation",
    "Invasiva-traqueotomía": "Invasive-tracheostomy",
    Normal: "normal",
    Reducida: "Reduced",
  };
  return texts[key];
};

export const RASSValues = new Array(11).fill(0).map((_, i) => i - 5);
export const optionValues = new Array(11).fill(0).map((_, i) => i);
export const positionValues = ["Encamado", "Sentado"];
export const deliriumValues = ["SÍ", "NO"];
export const mechanicalVentilationValues = ["NO", "No invasiva", "Invasiva-intubación", "Invasiva-traqueotomía"];
export const mobilityValues = ["Normal", "Reducida"];

export const evaluationPercentageKeys = [
  { key: "Delirium", values: [...deliriumValues, "-"] },
  { key: "MechanicalVentilation", values: [...mechanicalVentilationValues, "-"] },
  { key: "Position", values: [...positionValues, "-"] },
  { key: "Mobility", values: [...mobilityValues, "-"] },
];

export const activityIds = [
  protocols.icu.THE_UNIVERSE.id,
  protocols.icu.THE_BUTTERFLIES.id,
  protocols.icu.THE_AQUARIUM.id,
  protocols.icu.THE_NUMBERS.id,
  protocols.icu.THE_GARDEN.id,
  protocols.icu.THE_RIVER.id,
  protocols.icu.THE_BEACH.id,
];

export const islandId = [protocols.icu.WALK_AROUND_THE_ISLAND.id];

export const capsuleIds = [
  protocols.icu.SUNSET_AMONG_POPPIES.id,
  protocols.icu.CALM_IN_THE_LAKE.id,
  protocols.icu.FLYING_OVER_THE_FIELDS.id,
  protocols.icu.RELAX_ON_THE_BEACH.id,
  protocols.icu.THE_SOUND_OF_WATER.id,
  protocols.icu.THE_SWAY_OF_THE_WAVES.id,
];
